import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterLink, RouterOutlet} from '@angular/router';
import {PrimeNGConfig} from 'primeng/api';
import {MainNavComponent} from './shared/components/main-nav/main-nav.component';
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MsalBroadcastService} from '@azure/msal-angular';
import {filter, Subject, takeUntil} from 'rxjs';
import {InteractionStatus} from '@azure/msal-browser';
import {ApiAuthService} from '@core/services/api/api-auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    MainNavComponent,
    ToastModule,
    ConfirmDialogModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private readonly primengConfig: PrimeNGConfig,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly apiAuthService: ApiAuthService,
    private readonly router: Router
  ) {
  }

  async ngOnInit() {
    this.apiAuthService.setRoles();
    this.primengConfig.ripple = true;

    this.primengConfig.setTranslation({
      selectionMessage: '{0} items geselecteerd'
    });

    this.msalBroadcastService.inProgress$
      .pipe(
        // Filtering for all interactions to be completed
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.apiAuthService.authorized().subscribe(async (exists) => {
          if (!exists) {
            await this.router.navigate(['/unauthorized']);
          }
        });
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
